import React from 'react';
import PropTypes from 'prop-types';

import { HeaderWrapper, Header, SubHeader } from './styled';
import { map } from '../../../../util/lodashlike';

/**
 * MultiHeader
 * @param header {string}{required}
 * @param subHeader {string}{required}
 * @returns {JSX.Element}
 */
const MultiHeader = ({ header, subHeaders }) => (
  <HeaderWrapper>
    <Header>{header}</Header>
    {map(subHeaders, (item, idx) => (
      <SubHeader key={`sub_header_${idx}`}>{item}</SubHeader>
    ))}
  </HeaderWrapper>
);

MultiHeader.propTypes = {
  header: PropTypes.string.isRequired,
  subHeaders: PropTypes.array.isRequired
};

export default MultiHeader;
